


































































































































































































import {Vue, Component} from 'vue-property-decorator';
import { PopupRequestData } from '@/types';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

import {
  GetSmsAdBlockerRequest,
  GetSmsPublicAppkeyValidationRequest,
  PostSmsRequest
} from 'supporter';
import {addDay} from '@/utils/dateUtils';
import {ncpPopup} from '@/utils/ncp';
import {
  GetProductsRestockSendTargetsResponse,
  PutProductsRestockSendRequest
} from 'ncp-api-supporter/dist/types/modules/product/product';

type OptionType = 'DEFAULT' | 'COMBINATION';

@Component({
  components: {
    PageTitle,
    CompSelectBox,
    DateCalendar
  }
})
export default class SmsPopup extends Vue {
  private mallNo = 0;
  private smsUsed = false;
  private memberPhoneList: number[] = [];
  private senderno = '';
  private templateNo = 0;
  private templateType = '';
  private isAd = false;
  private isMsg = false;
  private isTemplateUsed = false;
  private isCheckOn = false;
  private sendType = 'SMS';
  private adBlockerNo = '';
  private isSendImmediate = true;
  private recipient = 'selectMember';
  private recipientType: 'MEMBER_NO' | 'DIRECT' = 'DIRECT'; // 'MEMBER_NO'(회원 번호) | 'DIRECT' (전화번호 가능)
  private sendInformationType = '';
  private title = '';
  private optionType: OptionType  = 'DEFAULT';
  private content = '';
  private copyContentDefaultValue = this.content;
  private previewTitle = '';
  private previewContents = '';
  private isPreview = false;
  private isAppKeyConfigured = false;
  private restockSendUpdateData: PutProductsRestockSendRequest = {
    restockNos: [],
    isSent: true
  };

  private created() {
    const {mallNo, optionType, mallName, optionNo, optionName, optionValue, productName} = this.$route.query;

    this.mallNo = Number(mallNo);
    this.optionType = optionType as OptionType;
    this.getProductsRestockSendTargets(optionNo);
    this.setSmsMsgTxt({mallName, optionName, optionValue, productName});
  }

  private async mounted() {
    await this.configurations();
    this.doSendImmediate();
    this.getAppKeyConfigured();
    this.senderno = this.sendernoList[0].senderno;
  }

  private async getProductsRestockSendTargets(optionNo): Promise<void> {
    const { data } = await this.$api.getProductsRestockSendTargets({params: {optionNo}});
    const getDataIntoAnArray = (type): number[] => data.map((user: GetProductsRestockSendTargetsResponse) => Number(user[type]));

    this.restockSendUpdateData.restockNos = getDataIntoAnArray('restockNo');
    this.memberPhoneList = getDataIntoAnArray('phone');
  }

  private setSmsMsgTxt(data): void {
    this.content = `${data.mallName}\n${data.productName}`;

    if (this.optionType === 'COMBINATION') {
      this.content += ` (${data.optionName} : ${data.optionValue})\n`;
    }
    this.content += ` ${this.$t('PRODUCT_RESTOCK_SMS_TXT')}`;

    this.copyContentDefaultValue = this.content;
  }

  private getWordCountWithMaxCount(msg, maxByte){
    let ret = 0;
    ret = this.getWordCount(msg, maxByte, true)[1];
    return ret>maxByte?maxByte:ret;
  }

  private getRealWordCount(msg, maxByte, isContent): number[]{
    let letter;
    let msgByte = this.isAd&&isContent?33:0;
    let msgLength = 0;
    const obj = [];

    for (let i = 0; i < msg.length; i++) {
      letter = msg.charAt(i);
      if (escape(letter).length > 4) {
        msgByte += 2;
      } else if (letter !== '\r') {
        msgByte += 1;
      }

      msgLength += 1;
    }
    obj[0] = msgLength;
    obj[1] = msgByte;

    return obj;
  }

  private openPop() {
    let queryString = '?mallNo=';

    // template popup 선택된 템플릿 데이터 가져오는 함수
    (window as any).membersCallback = (template) => {
      (window as any).membersCallback = undefined;
      this.title = template.title;
      this.templateType = template.type;
      this.sendType = template.type;
      this.content = template.content;
      this.templateNo = template.templateNo;
    };
    queryString += this.mallNo + '&callback=membersCallback';
    ncpPopup(`/sms/popup/template-list${queryString}`, this.$t('MANAGE_SMS_DISPATCH_TEMPLATE_INUSE'), 600, 400);
  }

  private getWordCount(msg, maxByte, isContent): number[]{
    let letter;
    let msgByte = this.isAd&&isContent?33:0;
    let msgLength = 0;
    const obj = [];

    for (let i = 0; i < msg.length; i++) {
      letter = msg.charAt(i);
      if (escape(letter).length > 4) {
        msgByte += 2;
      } else if (letter !== '\r') {
        msgByte += 1;
      }

      msgLength += 1;
      if (msgByte >= maxByte) {
        obj[0] = msgLength;
        obj[1] = msgByte;
        // obj[1] = maxByte;

        return obj;
      }
    }
    obj[0] = msgLength;
    obj[1] = msgByte;

    return obj;
  }
  private onChangeContent(msg, maxByte): void {
    this.content = this.content.substring(0, this.getWordCount(msg, maxByte, true)[0])
  }
  private onChangeTitle(msg, maxByte): void {
    this.title = this.title.substring(0, this.getWordCount(msg, maxByte, false)[0])
  }

  private sendernoList: any[] = [
    {
      senderno: 'MANAGE_SMS_DISPATCH_PLACEHOLDER_SENDNO'
    }
  ];



  // sms 유형 select 박스 change method
  private async changeSendInformationType() {

    if(this.sendInformationType === 'AD'){
      this.isAd = true;
      this.isMsg = false;

      // 2.  GET /sms/public-appkey/validation 返回成功
      // SMS유형 为 ‘광고성’时
      // 查询 GET /sms/ad-blocker 返回数据 (adBlockerNo is not empty)时  可填写内容发送操作 (avilable)状态
      // 查询 GET /sms/ad-blocker 失败，无数据时, alert ‘080 수신거부 번호 등록이 필요합니다.’
      if(this.isAd && this.isAppKeyConfigured){
        await this.getCallerid();
        if(this.senderno && this.senderno.length > 0){
          await this.getAdBlockerNo();
          if(this.adBlockerNo && this.adBlockerNo.length > 0){
            this.isCheckOn = true;
          }else{
            alert(this.$t('MANAGE_SMS_DISPATCH_ERR_BLOCKER'));
          }
        }else{
          alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDNO'));
        }

        let maxWordC = this.sendType==='SMS'?90:2000;
        if(this.getRealWordCount(this.content, maxWordC, true)[1] > maxWordC){
          this.content = this.content.substring(0, this.getWordCount(this.content, maxWordC, true)[0])
        }

      }
      // }else if($('#sendInformationType').prop('selectedIndex') === 1) {
    }else if(this.sendInformationType === 'INFORMATION'){
      this.isMsg = true;
      this.isAd = false;
      this.sendInformationType = 'INFORMATION';
      // 1. GET /sms/public-appkey/validation 返回 ➞ 400 T0002: 사용할 수 없는 앱키 时
      // alert此信息 '정보성/광고성 SMS를 모두 발송할수 없습니다. 앱키를 등록해주세요.'
      // 返回成功 但是 발신번호(sendNo) 无数据时 alert '발신번호를 등록해주세요'
      // 返回成功  + SMS유형 为 ‘정보성’ + 발신번호(sendNo) 有数据时 可填写内容发送操作 (avilable)状态
      if(this.isMsg && this.isAppKeyConfigured){
        await this.getCallerid();
        if(this.senderno && this.senderno.length > 0){
          this.isCheckOn = true;
        }else{
          alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDNO'));
        }
      }
    }else {
      this.isAd = false;
      this.isMsg = false;
    }
  }

  private changeTemplate() {
    if (!this.isTemplateUsed) {
      this.title = '';
      this.content = '';
    }
  }



  private doSendImmediate() {
    $('.timepicker').prop('disabled', this.isSendImmediate);
  }

  private startYmd: string = addDay(new Date(), 0);
  private calendarOption = {
    fromRanges: addDay(new Date(), 0)
  };

  private selectHour: string = '00';
  private get hourList() {
    let hours = [];
    for (let i = 0; i <= 23; i++) {
      let j = '';
      if (i < 10) {
        j = '0' + i;
      } else {
        j = '' + i;
      }
      hours.push({
        value: j,
        name: j
      });
    }
    return hours;
  }

  private selectMinute: string = '00';
  private get minuteList() {
    let minute = [];
    for (let i = 0; i <= 5; i++) {
      let j = '' + i + '0';
      minute.push({
        value: j,
        name: j
      });
    }
    return minute;
  }

  private onReset(): void {
    this.isAppKeyConfigured = false;
    this.getAppKeyConfigured();
    this.sendInformationType = '';
    this.isCheckOn = false;
    this.isAd = false;
    this.isMsg = false;
    this.sendernoList = [
      {
        senderno: 'MANAGE_SMS_DISPATCH_PLACEHOLDER_SENDNO'
      }
    ];
    this.senderno = this.sendernoList[0].senderno;
    this.adBlockerNo = '';
    this.changeSendInformationType();
    this.isTemplateUsed = false;
    this.sendType = 'SMS';
    this.recipient = 'selectMember';
    this.isSendImmediate = true;
    this.doSendImmediate();
    this.title = '';
    this.startYmd = addDay(new Date(), 0);
    this.selectHour = '00';
    this.selectMinute = '00';
    this.content = this.copyContentDefaultValue;
  }

  private onPreview(): void {
    if (this.isAd) {
      this.previewContents = this.$t('MANAGE_SMS_DISPATCH_TITLE_AD') + '\n' + this.content + '\n' + this.$t('MANAGE_SMS_DISPATCH_CONTENT_AD') + this.adBlockerNo;
    } else {
      this.previewContents = this.content;
    }

    if (this.sendType === 'SMS') {
      this.previewTitle = '';
    } else {
      this.previewTitle = this.title;
    }
    this.isPreview = true;
  }


  private onSave(): void {
    let maxContentLength = this.sendType === 'SMS' ? 90 : 2000;
    if (this.isFormPassed()) {
      const request: PostSmsRequest = {
        params: {
          mallNo: this.mallNo
        },
        data: {
          templateNo: this.isTemplateUsed?this.templateNo:null,
          recipientType: this.recipient === 'all'?'ALL':this.recipientType,
          messageType: this.sendInformationType === '' ? 'INFORMATION' : this.sendInformationType,
          recipients: this.memberPhoneList, // sms 보낼 사용자 번호 리스트
          requestDateTime: this.isSendImmediate?null:(this.startYmd + ' ' + this.selectHour + ':' + this.selectHour + ':00'),
          title: this.title.length > 40 ? this.title.substr(0, 40) : this.title,
          content: this.isAd && this.content.length > maxContentLength ? this.content.substr(0, this.content.length - (1 + 26)) : this.content,
          adBlockerNo: this.adBlockerNo,
          smsType: this.sendType,
          outboundCallerId: this.senderno
        }
      };

      this.$api.postSms(request).then(() => {
        alert(this.$t('MANAGE_SMS_DISPATCH_SUCCESS_SEND'));

        this.$api.putProductsRestockSend(this.restockSendUpdateData);
        window.opener.location.reload();
        this.onReset();
      });
    }
  }

  private isFormPassed(): boolean {
    // Email Appkey 확인
    if (!this.isAppKeyConfigured) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_APP_KEY'));
      return false;
    }

    if (!this.sendType) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDTYPE'));
      return false;
    }

    if (this.isTemplateUsed) {
      if (this.templateType === '') {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TEMPLATESENDTYPE_NULL'));
        return false;
      }
      if (this.templateType !== this.sendType) {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TEMPLATESENDTYPE'));
        return false;
      }
    }

    if (!this.senderno) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDERNO'));
      return false;
    }

    if (this.memberPhoneList.length === 0) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_RECIPIENT_COUNT'));
      return false;
    }

    if (!this.isSendImmediate) {
      const _MINUTE_STANDARD = 10;
      const date = this.startYmd.split('-');
      const targetDate = new Date(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]), parseInt(this.selectHour), parseInt(this.selectMinute));
      const now = new Date();
      targetDate.setMinutes(targetDate.getMinutes() - _MINUTE_STANDARD);
      if (targetDate.getTime() - now.getTime() < 0) {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TIME'));
        return false;
      }
    }
    if (this.sendType === 'LMS' && !this.title) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TITLE'));
      return false;
    }
    if (!this.content) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SUMMERNOTE'));
      return false;
    }
    return true;
  }

  private getAppKeyConfigured(): void {
    let request: GetSmsPublicAppkeyValidationRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getSmsPublicAppkeyValidation(request).then(() => {
      this.isAppKeyConfigured = true;
    })
        .catch((e: any) => {
          if (e.data.code === 'T0002') {
            alert(this.$t('MANAGE_SMS_DISPATCH_ERR_APPKEY'));
          }
        });

  }

  private async getAdBlockerNo() {
    let request: GetSmsAdBlockerRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    await this.$api.getSmsAdBlocker(request).then(ret => {
      this.adBlockerNo = ret.data.adBlockerNo;
    });
  }

// 10. 수동발송 발신번호 조회
// GET /sms/outbound-caller-id/public
// https://docs.e-ncp.com/?urls.primaryName=manage-api#/SMS/get-public-outbound-caller-id-list
  private async getCallerid() {
    let request = {
      params: {
        mallNo: this.mallNo
      }
    };
    await this.$api.getSmsOutboundcalleridPublic(request).then(ret => {
      this.sendernoList = [];
      ret.data.sendNos.forEach((elem: string) => {
        this.sendernoList.push({
          // senderno: elem.replace(/-/gi, '')
          senderno: elem
        });
      });
      this.senderno = this.sendernoList[0].senderno;
    });
  }

  private dispatchPreviewPopupRequestData: PopupRequestData = {
    id: 'previewcontent',
    width: 280,
    maxHeight: 800,
    title: 'MANAGE_SMS_DISPATCH_TITLE_PREVIEW',
    hasConfirmBtn: false,
    hasCloseBtn: true
  };


  private async configurations() {
    const configRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
        .getNotificationsConfigurations(configRequest)
        .then(res => {
          this.smsUsed = res.data.smsUsed;
        })
        .catch((e: any) => {
          if (e.data.code === 'MC0002') {
            this.smsUsed = false;
          }
        });
    if(!this.smsUsed){
      window.location.assign(`/sms/usage-list?mallNo=${this.mallNo}&tabNo=5`);
    }
  }

}
